import { render, staticRenderFns } from "./ReadingTask3.vue?vue&type=template&id=7102d772&scoped=true&"
import script from "./ReadingTask3.vue?vue&type=script&lang=ts&"
export * from "./ReadingTask3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7102d772",
  null
  
)

export default component.exports